import { render } from "./LogoFrame.vue?vue&type=template&id=6bac3363"
import script from "./LogoFrame.vue?vue&type=script&lang=js"
export * from "./LogoFrame.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__